import {ActionContext} from "vuex";
import Vue from "vue";
import {IAppState} from "@/interfaces/store-interfaces/app-state.interface";
import {IDialogStoreState} from "@/interfaces/store-interfaces/dialog.interface";
import {ModuleStore} from "@/interfaces/store-interfaces/module-store.interface";

type DialogActionContext = ActionContext<IDialogStoreState, IAppState>;

const defaultState: IDialogStoreState = {
  payload: {},

  callbackForm: false,
  menu: false,
};

export default {
  namespaced: true,

  state: {
    payload: {},

    callbackForm: false,
    menu: false,
  },

  mutations: {
    setPropertyInState(state: ModuleStore.IState, { name, value }: { name: string, value: any }) {
      Vue.set(state, name, value);
    },
    
    openDialog(state: IDialogStoreState, { dialogName, payload }: { dialogName: string, payload?: any } ) {
      Vue.set(state, dialogName, true);
      if (payload) {
        state.payload = payload;
      }
    },

    closeDialog(state: IDialogStoreState, { dialogName }: { dialogName: string } ) {
      Vue.set(state, dialogName, false);
      state.payload = defaultState.payload;
    },

    closeAllDialogs(state: IDialogStoreState) {
      for (let dialog in state) {
        Vue.set(state, dialog, defaultState[dialog]);
      }
      state.payload = defaultState.payload;
    }
  },

  actions: {
  }
};
